import { TextField, Typography } from '@material-ui/core';
import { get } from 'lodash';
import React from 'react';
import {
  InputTextWidget,
  DropdownWidget,
  InputDateWidget,
  InputSearchField,
  CheckboxInputWidget,
} from './FormWidgets';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    background: '#ffffff',
    padding: '8px 32px',
    // marginRight:32,
  },
  fieldTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '20%',
  },
}));

const InputField = ({ key, value, setFormState, hint, formData, ...props }) => {
  React.useEffect(() => {
    value && setFormState({ [key]: value });
  }, [value]);
  return (
    <>
      <TextField
        label={hint}
        inputProps={{
          placeholder: props.hint || 'Enter Text',
        }}
        variant="outlined"
        size="small"
        disableUnderline
        value={formData[key] || ''}
        onChange={(event) => props.setFormState({ [key]: event.target.value })}
        autoFocus
        multiline
        fullWidth
        rowsMax={3}
        style={{ color: '#505050' }}
      />
    </>
  );
};

const fieldTypeReducer = {
  0: InputTextWidget,
  1: DropdownWidget,
  2: InputDateWidget,
  3: InputSearchField,
  4: CheckboxInputWidget,
};

export default function FormGroup(props) {
  const { group, formState } = props;
  const classes = useStyles();

  return (
    <div
      className={classes.formContainer}
      style={{ marginLeft: props.index != 0 && '10%' }}
    >
      {group.fields &&
        group.fields.map((field, index) => {
          const FieldComponent = get(fieldTypeReducer, field.fieldType, <></>);
          return (
            <div style={{ display: 'flex' }}>
              <div className={classes.fieldTitle}>
                {field.label || field.hint}
              </div>
              <div style={{ width: '80%' }}>
                {field.multipleFields ? (
                  <div style={{ width: '100%', display: 'flex' }}>
                    {field.subFields &&
                      field.subFields.map((subField, i) => {
                        const FieldElement = get(
                          fieldTypeReducer,
                          subField.fieldType,
                          <></>
                        );
                        return (
                          <div
                            style={{
                              width: '50%',
                              display: subField.postFixText && 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              margin: !subField.postFixText && 'auto',
                            }}
                          >
                            <FieldElement
                              autoFocus={props.focus && index === 0 && i === 0}
                              _key={subField.key}
                              {...props.formHandlers}
                              {...subField}
                              {...props}
                            />
                            <Typography>{subField.postFixText}</Typography>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <FieldComponent
                    autoFocus={props.focus && index === 0}
                    _key={field.key}
                    {...props.formHandlers}
                    {...field}
                    {...props}
                  />
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
}
